import { Component, OnInit, Input } from '@angular/core';
import { FileUploader } from 'ng2-file-upload';
import { FormGroup } from '@angular/forms';
import { IngUpload } from '../../inputs';

@Component({
  selector: 'ing-upload',
  templateUrl: './ing-upload.component.html',
  styleUrls: ['./ing-upload.component.scss']
})
export class IngUploadComponent implements OnInit {
  @Input() form:  FormGroup;
  @Input() input: IngUpload<string>;

  public uploader: FileUploader;
  public hasBaseDropZoneOver: boolean = false;
  public hasAnotherDropZoneOver: boolean = false;
 
  constructor() {
    this.uploader = new FileUploader({url: ''});
    this.uploader.authToken = '';
  }

  ngOnInit() {
    this.input.controlType = 'ing-upload';

    console.log(this.uploader);

    this.form.controls[this.input.key].setValue(this.uploader);
  }

  public fileOverBase(e:any):void {
    this.hasBaseDropZoneOver = e;
    console.log(e);
    console.log(this.uploader);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/ing-dynamic-form/dynamic-form/ing-upload/ing-upload.component.ts